<template>
  <transition name="el-fade-in-linear">
    <div class="index">
      <router-link to="/Solution">
        <img class="backPic" src="../../static/images/back.png" />
      </router-link>
      <div class="container">
        <img
          class="solutionDetailTitle1"
          src="../../static/images/solutionText8.png"
        />
        <br />
        <img
          class="solutionDetailTitle2"
          src="../../static/images/solutionText9.png"
        />
        <!--
        <div
          class="solutionDetailText"
        >北斗院提供全域交通的行业解决方案，具备丰富的城市道路交通、轨道交通、公共运输等行业经验。以交通大数据为核心，用数据智能为智慧交通行业赋能，从全新的视角重构和提升智慧交通业务智能化水平。面向交通行业管理部门机构提供“创新产品+解决方案+工程交付+运维维护” 的完整产业链服务。</div>
        -->
        <div class="solutionDetailFlex">
          <div class="solutionDetailItem">
            <div class="solutionDetailSecondTitle">TOS系统</div>
            <div class="solutionDetailSecondText">
              TOS系统基于实时售检票数据，依托客流引擎算法，实现对地铁线网、线路、站点、区间客流的实时计算，实现对地铁客流的量化监测和分析管理，提高线网运营的智能化监管水平。
            </div>
          </div>
          <div class="solutionDetailItem">
            <img
              class="solutionDetailPic"
              src="../../static/images/solutionDetailPic13.jpg"
            />
          </div>
        </div>

        <div class="solutionDetailThirdFlex">
          <div class="solutionDetailItem">
            <img
              class="solutionDetailPic"
              src="../../static/images/solutionDetailPic14.jpg"
            />
          </div>
          <div class="solutionDetailItem">
            <div class="solutionDetailSecondTitle">清分系统</div>
            <div class="solutionDetailSecondText">
              清分系统主要用于估计乘客在实际出行中的换乘路径选择行为，通过计算OD间所有有效出行路径（即路网中实际被乘客选择的出行路径）及各条路径被选择概率来确定联网运营模式下各运营主体的票务收入。
            </div>
          </div>
        </div>
        <div class="solutionDetailThirdFlex">
          <div class="solutionDetailItem">
            <div class="solutionDetailSecondTitle">地铁一体化商业管理平台</div>
            <div class="solutionDetailSecondText">
              地铁一体化商业管理平台是针对地铁范围内的广告资源及商业资源，提供信息化、可视化、智能化的管理工具，从而提高管理效率、商业收入和社会价值；同时结合客流、POI、消费行为等数据，通过AI算法为广告投放和商铺业态提供决策支撑。
            </div>
          </div>
          <div class="solutionDetailItem">
            <img
              class="solutionDetailPic"
              src="../../static/images/solutionDetailPic15.jpg"
            />
          </div>
        </div>
        <div class="solutionDetailThirdFlex">
          <div class="solutionDetailItem">
            <img
              class="solutionDetailPic"
              src="../../static/images/solutionDetailPic16.jpg"
            />
          </div>
          <div class="solutionDetailItem">
            <div class="solutionDetailSecondTitle">票价生成软件</div>
            <div class="solutionDetailSecondText">
              基于线网参数、票价参数、地图参数，利用核心智能算法，实现线网票价表、计费路径表、计费里程（时间）表、车站票价表的生成，支持通过线网图实现票价查询的可视化
            </div>
          </div>
        </div>
        <div class="solutionDetailThirdFlex">
          <div class="solutionDetailItem">
            <div class="solutionDetailSecondTitle">方案概述</div>
            <div class="solutionDetailSecondText">
              北斗院智能智慧轨道解决方案基于物联网、大数据、人工智能、三维地理信息等技术，深度挖掘各类轨道运营数据，覆盖运营管理、商业管理、安全管理、人员管理等业务板块，构建轨道智能决策大脑。
            </div>
          </div>
          <div class="solutionDetailItem">
            <img
              class="solutionDetailPic"
              src="../../static/images/solutionDetailPic17.jpg"
            />
          </div>
        </div>
      </div>
      <div class="bottomFoot">
        <Foot />
      </div>
    </div>
  </transition>
</template>


<script>
import Foot from "./Foot";

export default {
  name: "Index",
  data() {
    return {};
  },
  components: {
    Foot,
  },
  mounted: function () {
    this.$router.afterEach((to, from, next) => {
      window.scrollTo(0, 0);
    });
  },
  methods: {},
};
</script>
<style scoped>
@import "./solutionDetail.css";
</style>



// WEBPACK FOOTER //
// src/views/SolutionDetail4.vue